const getLastMatchingChild = (currentPath, children) => {
  let matchingChild = null

  for (const child of children) {
    if (currentPath.includes(child.path)) matchingChild = child
  }

  return matchingChild
}

export const getSelectedTab = (currentPath, tabs) => {
  let selectedTab = null

  for (let tab of tabs) {
    if (currentPath.includes(tab.path)) {
      selectedTab = tab
    } else if (tab.children) {
      selectedTab = getLastMatchingChild(currentPath, tab.children) || selectedTab
    }
  }

  if (!selectedTab) {
    selectedTab = tabs[0]?.children?.length ? tabs[0].children[0] : tabs[0]
  }

  return selectedTab
}
